import { useEffect, useRef } from "react";

type ShiftMeta = { shiftId: string; workcenterId: number };
type OnVisible = (meta: ShiftMeta) => void;

export function useShiftVisibilityObserver(onVisible: OnVisible) {
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const target = entry.target as HTMLElement;
          const shiftId = target.dataset.shiftId;
          const workcenterId = Number(target.dataset.workcenterId);
          if (entry.isIntersecting) {
            if (shiftId && !isNaN(workcenterId)) {
              onVisible({ shiftId, workcenterId });
            }
          }
        });
      },
      { threshold: 0.5 } // 50% visible
    );

    return () => observer.current?.disconnect();
  }, [onVisible]);

  const observe = (el: HTMLElement | null) => {
    if (el && observer.current) {
      observer.current.observe(el);

      const rect = el.getBoundingClientRect();
      const inViewport = rect.height > 0 &&
          rect.top < window.innerHeight &&
          rect.bottom > 0;
      if (inViewport) {
          const shiftId = el.dataset.shiftId;
          const workcenterId = Number(el.dataset.workcenterId);
          if (shiftId && !isNaN(workcenterId)) {
            onVisible({ shiftId, workcenterId });
          }
      }
    }
  };

  return { observe };
}
